<template lang="pug">
div
  .text-lg.font-semibold {{ getDate }}
  .text-md.font-normal.mb-8 {{ getTime }}, {{ selectedHistory.record_date | convertToRelativeCalendar }}
    span(v-if="getDoctorName") , {{ $t('attended_by', { who:'' }).toLowerCase() + getDoctorName }}
  .text-md.font-semibold.mb-3 {{ getDiagnosisTitle }}
  .text-sm.neutral500--text(v-html="getNote")
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    selectedHistory: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      open: true
    }
  },
  computed: {
    getDate() {
      return DateTime.fromISO(this.selectedHistory.record_date).toFormat('dd MMM y')
    },
    getTime() {
      return DateTime.fromISO(this.selectedHistory.record_date).toFormat('h:mm a').toLowerCase()
    },
    getDoctorName() {
      return this.selectedHistory?.provider?.name || null
    },
    getDiagnosisTitle() {
      const diagnoses = this.selectedHistory.consultation?.diagnoses ?? []
      return `${this.$t('diagnosis')} : ${diagnoses.join(', ')}`
    },
    getNote() {
      return this.selectedHistory.consultation?.note
    }
  },
}
</script>

<style lang="scss" scoped>
</style>